import { CheckCircleRounded, DoneRounded } from "@mui/icons-material";
import { Button, Chip } from "@mui/material";
import { grey } from "@mui/material/colors";
import { sectionCompletedStatus, sectionDetailsColumns } from "./data";

const SectionCompleteButton = ({ sectionDetails, onComplete, disabled = false }) => {
	const isCompleted =
		sectionDetails?.[sectionDetailsColumns.is_completed.key] === sectionCompletedStatus;

	if (isCompleted) {
		return (
			<Chip
				size="small"
				icon={<CheckCircleRounded fontSize="small" />}
				label="Completed"
				color="success"
				variant="outlined"
				sx={{ fontWeight: 700, height: 30, px: 0.5 }}
			/>
		);
	}

	return (
		<Button
			size="small"
			variant="contained"
			disabled={disabled}
			onClick={onComplete}
			startIcon={<DoneRounded />}
			sx={{
				textTransform: "none",
				fontWeight: 700,
				backgroundColor: grey[800],
				color: "#fff",
				"&:hover": { backgroundColor: grey[900] },
			}}>
			Mark Complete
		</Button>
	);
};

export default SectionCompleteButton;
